import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal, output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatTab, MatTabGroup} from '@angular/material/tabs';

import {
  CategoryModel,
  DrawingModel, EventModel,
  EventRankingModel,
  GameModel,
  GroupRankingModel,
  TournamentCategoryModel,
  TournamentModel,
} from 'shared/models';
import {
  TournamentsCategoriesEventsOverviewUi
} from '../tournaments-categories-events-overview-ui/tournaments-categories-events-overview-ui';
import {EventUi} from '../event-ui/event-ui';

@Component({
  selector: 'tournament-category-ui',
  standalone: true,
  imports: [CommonModule, EventUi, MatCard, MatCardContent, MatTab, MatTabGroup, MatCardHeader, MatCardTitle, TournamentsCategoriesEventsOverviewUi],
  templateUrl: './tournament-category-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentCategoryUi {
  tournament: InputSignal<TournamentModel> = input.required<TournamentModel>();
  categories: InputSignal<CategoryModel[]> = input.required<CategoryModel[]>();
  activeTab: InputSignal<number> = input.required<number>();
  tabChange: OutputEmitterRef<number> = output<number>();

  tournamentCategory: InputSignal<TournamentCategoryModel> = input.required<TournamentCategoryModel>();
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();
  groupsRankings: InputSignal<GroupRankingModel[]> = input.required<GroupRankingModel[]>();
  eventsRankings: InputSignal<EventRankingModel[]> = input.required<EventRankingModel[]>();

  protected tournamentCategoryDrawings: Signal<DrawingModel[]> = computed((): DrawingModel[] => {
    const tournamentCategory: TournamentCategoryModel = this.tournamentCategory();
    const drawings: DrawingModel[] = this.drawings();
    return drawings.filter((model: DrawingModel): boolean => {
      return model.tournamentCategoryId === tournamentCategory.id;
    });
  });

  // protected categoryGroupsDrawings = computed((): DrawingModel[] => {
  //   const drawings: DrawingModel[] = this.categoryDrawings();
  //   return drawings.filter((model: DrawingModel): boolean => {
  //     // @TODO: usar enum
  //     return model.stage === 'groups';
  //   });
  // });
  //
  // protected categoryGroupNames = computed((): string[] => {
  //   const data: DrawingModel[] = this.categoryGroupsDrawings();
  //   const groups: string[] = data.map((model: DrawingModel): string => {
  //     return model.group;
  //   });
  //   // Unique
  //   return [...new Set(groups)];
  // });

  protected tournamentCategoryGames: Signal<GameModel[]> = computed((): GameModel[] => {
    const tournamentCategory: TournamentCategoryModel = this.tournamentCategory();
    const games: GameModel[] = this.games();
    return games.filter((model: GameModel): boolean => {
      return model.tournamentCategoryId === tournamentCategory.id;
    });
  });

  // protected categoryGroupsGames = computed((): GameModel[] => {
  //   const games: GameModel[] = this.categoryGames();
  //   return games.filter((model: GameModel): boolean => {
  //     // @TODO: usar enum
  //     return model.stage === 'groups';
  //   });
  // });
  //
  // protected categoryPlayedGroupsGames = computed((): GameModel[] => {
  //   const games: GameModel[] = this.categoryGroupsGames();
  //   return games.filter((model: GameModel): boolean => {
  //     // @TODO: usar enum
  //     return model.status === 'finished';
  //   });
  // });
  //
  // private categoryDrawsNumPlayers = computed((): number => {
  //   const numGroups: number = this.categoryGroupNames().length;
  //   // @TODO: sacar de la configuracion
  //   const numClassifiedsPlayersPerGroup = 2;
  //   return numGroups * numClassifiedsPlayersPerGroup;
  // });
  //
  // protected categoryDrawsNumGames = computed((): number => {
  //   const numPlayers: number = this.categoryDrawsNumPlayers();
  //   if (numPlayers == 0) {
  //     return 0;
  //   }
  //   return numPlayers - 1;
  // });
  //
  // private categoryDrawsGames = computed((): GameModel[] => {
  //   const games: GameModel[] = this.categoryGames();
  //   return games.filter((model: GameModel): boolean => {
  //     // @TODO: usar enum
  //     return model.stage !== 'groups';
  //   });
  // });
  //
  // protected categoryPlayedDrawsGames = computed((): GameModel[] => {
  //   const data: GameModel[] = this.categoryDrawsGames();
  //   return data.filter((model: GameModel): boolean => {
  //     // @TODO: usar enum
  //     return model.status === 'finished';
  //   });
  // });
  //
  // protected categoryGroupsRankings = computed((): GroupRankingModel[] => {
  //   const tournamentCategory: TournamentCategoryModel = this.tournamentCategory();
  //   const groupsRankings: GroupRankingModel[] = this.groupsRankings();
  //   // @TODO: arreglar
  //   // return groupsRankings.filter((model: GroupRankingModel): boolean => {
  //   //   return model.categoryId === category.id;
  //   // });
  //   return [];
  // });

  protected tournamentGroupsRankings: Signal<GroupRankingModel[]> = computed((): GroupRankingModel[] => {
    const tournamentCategory: TournamentCategoryModel = this.tournamentCategory();
    const groupsRankings: GroupRankingModel[] = this.groupsRankings();
    return groupsRankings.filter((model: GroupRankingModel): boolean => {
      return model.tournamentCategoryId === tournamentCategory.id;
    });
  });

  protected tournamentEventsRankings: Signal<EventRankingModel[]> = computed((): EventRankingModel[] => {
    const tournamentCategory: TournamentCategoryModel = this.tournamentCategory();
    const eventsRankings: EventRankingModel[] = this.eventsRankings();
    return eventsRankings.filter((model: EventRankingModel): boolean => {
      return model.tournamentCategoryId === tournamentCategory.id;
    });
  });

  protected rootEvents = computed((): EventModel[] => {
    const events: EventModel[] = this.tournamentCategory().events || [];

    const rootEvents: EventModel[] = events.filter((event: EventModel): boolean => {
      return !event.parentId;
    });
    rootEvents.forEach((event: EventModel): void => {
      event.children = events.filter((e: EventModel): boolean => {
        return e.parentId === event.id;
      });
    });

    return rootEvents;
  });
}
